export function getIdealPageSize() {
  return window.innerWidth > 2000 ? 50 : window.innerWidth > 1600 ? 30 : 16;
}
